import React, { useEffect } from 'react';
import { Spinner } from 'components';

// Mirror of v2's `/app/switching-version` route. The fact that THIS code
// renders means monster-worker just routed the iframe to v1's CloudFront.
//
//   target='1' → rollback complete, we're v1, send merchant to v1 home.
//   else       → still in transition (e.g. upgrade target=2 but worker
//                hasn't caught up yet). Render the limbo; the auto-reload
//                re-hits monster-worker every 5s until DDB consistency
//                propagates and the worker routes to v2.
//
// No /allowed-version fetch: we don't need to ask DDB what state we're in —
// the worker already decided by routing us here.
const RELOAD_INTERVAL_MS = 5000;

export default function SwitchingVersionScreen() {
    // Auto-reload every 5s as the transition mechanism: each reload re-hits
    // monster-worker, which re-reads appVersion and may route the iframe to
    // the other side once DDB consistency catches up.
    useEffect(() => {
        const id = setInterval(() => window.location.reload(), RELOAD_INTERVAL_MS);
        return () => clearInterval(id);
    }, []);

    // On mount: if the caller flagged target='1' (rollback), we're the right
    // server — redirect to v1 home. The reload preserves embed query params
    // (host, shop, etc.) so v1's home can re-init App Bridge correctly.
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        if (params.get('target') === '1') {
            window.location.href = '/' + window.location.search;
        }
    }, []);

    return (
        <div
            style={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 24,
                fontFamily:
                    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
            }}
        >
            <div
                style={{
                    maxWidth: 480,
                    textAlign: 'center',
                    background: '#fff',
                    border: '1px solid #e1e3e5',
                    borderRadius: 8,
                    padding: 32
                }}
            >
                <div style={{ marginBottom: 16 }}>
                    <Spinner />
                </div>
                <h2 style={{ margin: '0 0 12px', fontSize: 20, fontWeight: 600 }}>
                    Switching your store version
                </h2>
                <p style={{ margin: '0 0 20px', color: '#6d7175', lineHeight: 1.5 }}>
                    We're switching your store. Please refresh this page to continue —
                    we'll auto-refresh every few seconds as a fallback.
                </p>
                <button
                    type="button"
                    onClick={() => window.location.reload()}
                    style={{
                        background: '#000',
                        color: '#fff',
                        border: 'none',
                        borderRadius: 4,
                        padding: '10px 20px',
                        fontWeight: 600,
                        cursor: 'pointer'
                    }}
                >
                    Refresh now
                </button>
            </div>
        </div>
    );
}
